import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { PROMOCIONES_LISTA, PROMOCIONES_NUEVOACTUALIZAR } from 'constants/codigosTransacciones'

import ListaPage from './lista'
import NuevoActualizarPage from './nuevoActualizar'

export default function PromocionesPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${PROMOCIONES_LISTA}`} component={ListaPage} />
        <Route path={`/${PROMOCIONES_NUEVOACTUALIZAR}/:id`} component={NuevoActualizarPage} />
        <Route path={`/${PROMOCIONES_NUEVOACTUALIZAR}`} component={NuevoActualizarPage} />
      </Switch>
    </Suspense>
  )
}
